import { translations } from '../Translations'

export const checkTranslation = (code) => translations.en[code] 